import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'ADD_TO_OPER',
  title: 'Come posso aggiungere un\' impresa ad un\'operazione?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Fare clic sulla scheda «Operazioni»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Clicca sull\'operazione di tua scelta'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Clicca in alto a destra su «Aggiungere un\'azienda»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Seleziona il ruolo dell\' impresa'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Indicare il Codice Fiscale o il nome dell\'impresa'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Se l\'impresa è presente sulla piattaforma:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Fare clic sul nome'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Poi fare clic su validare per aggiungerla alla vostra operazione'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '7.',
    value: 'Se l\'impresa non è presente sulla piattaforma:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Fare clic sul pulsante «Invitare l\'impresa "Nome dell\'impresa" ad unirsi alla rete»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_7.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Inserisci le coordinate dell\'azienda'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_8.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Fare clic su validare'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_9.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Quindi validare'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ADD_TO_OPER/IT_ADD_TO_OPER_11.png`
  }]
};
